import React, { useEffect } from "react";
import Drawer from "./Drawer";
import { useNavigate, useParams } from "react-router-dom"; // Added useParams import
import { useHome } from "../../hooks/useHome";
import { useDispatch, useSelector } from "react-redux";
import { setMenus } from "../../store/slices/uiSlice";
import Logo from "./Logo";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";

interface HeaderProps {
  tabs?: { id: number; type: string; label: string }[];
  onTabClick?: (tab: { id: number; type: string }) => void;
  selectedFilter?: {
    id: number;
    type: string;
    label: string;
  };
  renderBottomNav?: any;
  renderFilter?: any;
  isBack?: boolean;
  className?: string; // Optional className prop for additional styling
}

const Header: React.FC<HeaderProps> = ({
  tabs,
  onTabClick,
  selectedFilter,
  renderBottomNav,
  renderFilter,
  isBack = false, // Default to false if not provided
  className = "", // Default to empty string if not provided
}) => {
  const { dashboardQuery } = useHome();
  const dispatch = useDispatch();
  const menus = useSelector((state: any) => state.ui.menus);
  const [isDrawerOpen, setDrawerOpen] = React.useState(false);
  const navigate = useNavigate();
  const { lang } = useParams<{ lang: string }>(); // Retrieve lang from URL

  // Lưu dữ liệu vào store khi có dữ liệu từ API
  useEffect(() => {
    if (dashboardQuery.data?.data?.menus) {
      dispatch(setMenus(dashboardQuery.data.data.menus));
    }
  }, [dashboardQuery.data, dispatch]);

  const toggleDrawer = () => {
    setDrawerOpen(!isDrawerOpen);
  };

  const handleSearchClick = () => {
    navigate(`/${lang || "vi"}/search/`); // Include lang in the search path
  };

  const handleBackClick = () => {
    navigate(-1); // Navigate back to the previous page
  };

  return (
    <div
      className={`header-container text-white w-full sticky top-0 z-50 items-center ${className}`}
    >
      {/* Header */}
      <div className="header  linear-red-bg   h-16 flex items-center justify-between relative">
        <div className="grid grid-cols-3 items-center px-2 relative w-full">
          {/* Menu and Back buttons */}
          <div className="flex items-center">
            {isBack && (
              <button
                onClick={handleBackClick}
                className="text-white bg-transparent px-2"
              >
                <img
                  src="/assets/icons/back.svg"
                  alt="Back"
                  className="w-6 h-6"
                />
              </button>
            )}
            <button
              onClick={toggleDrawer}
              className="text-white bg-transparent px-2"
            >
              <img
                src="/assets/icons/menu-icon.svg"
                alt="Menu"
                className="w-6 h-6"
              />
            </button>
          </div>

          <div className="flex justify-center">
            <Logo width={120} height={36} variant="vertical" />
          </div>

          {/* Search Icon */}
          <div className="flex items-center gap-2 justify-end">
            {renderFilter && renderFilter}
            <button
              onClick={handleSearchClick}
              className="text-white bg-transparent px-2"
            >
              <img
                src="/assets/icons/search-icon.svg"
                alt="Search"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>

        {/* Tabs Section */}
        {tabs && (
          <div
            data-attr="scroll-container"
            className="nav-tabs  bg-transparent"
          >
            <Swiper
              spaceBetween={8}
              slidesPerView="auto"
              className="!pt-2 pb-3"
              style={{ paddingLeft: 0, paddingRight: 0 }}
            >
              {tabs.map((tab: any, idx) => (
                <SwiperSlide
                  key={tab.id || idx}
                  style={{ width: "auto" }}
                  className="ml-4"
                >
                  <button
                    onClick={() => onTabClick?.(tab)}
                    className={`px-4 py-2 rounded-full ${
                      (selectedFilter?.id || 0) === tab.id
                        ? "bg-white text-primary border font-bold"
                        : "bg-transparent text-white font-medium"
                    }`}
                  >
                    {tab.label || "Tab"}
                  </button>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}
        {renderBottomNav && renderBottomNav}
      </div>

      {/* Drawer */}
      <Drawer
        navbar={menus || []}
        isOpen={isDrawerOpen}
        onClose={() => setDrawerOpen(false)}
      />

      {/* Bottom Navigation */}
    </div>
  );
};

export default Header;

/* Thêm đoạn CSS sau vào global stylesheet (ví dụ: index.css hoặc App.css):
.scrollbar-hidden::-webkit-scrollbar {
  display: none;
}
.scrollbar-hidden {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
*/
